/* Oergezond bestsellers (v3.14): productfoto's hebben verschillende witranden, waardoor het ene potje
   klein en hoog staat en het andere groot. Meet per foto de echte omtrek van het product (alpha)
   en schaal/verschuif zodat elk product even groot en exact in het midden staat. */
(function () {
  var MAXW = 0.60, MAXH = 0.70, MAXS = 2.6;
  function fit(img) {
    if (img.dataset.lxFit) return;
    img.dataset.lxFit = '1';
    var src = img.currentSrc || img.src;
    var probe = new Image();
    probe.onload = function () {
      try {
        var N = 96, c = document.createElement('canvas');
        c.width = c.height = N;
        var x = c.getContext('2d', { willReadFrequently: true });
        x.drawImage(probe, 0, 0, N, N);
        var d = x.getImageData(0, 0, N, N).data;
        var l = N, t = N, r = -1, b = -1;
        for (var y = 0; y < N; y++) for (var i = 0; i < N; i++) {
          if (d[(y * N + i) * 4 + 3] > 24) { if (i < l) l = i; if (i > r) r = i; if (y < t) t = y; if (y > b) b = y; }
        }
        if (r < 0) return;
        var bw = (r - l + 1) / N, bh = (b - t + 1) / N;
        if (bw > .97 && bh > .97) return; // geen transparante achtergrond: laten staan
        var cx = (l + r + 1) / 2 / N, cy = (t + b + 1) / 2 / N;
        var s = Math.min(MAXW / bw, MAXH / bh, MAXS);
        img.style.setProperty('--fs', s.toFixed(3));
        img.style.setProperty('--fx', (-(cx - .5) * s * 100).toFixed(2) + '%');
        img.style.setProperty('--fy', (-(cy - .5) * s * 100).toFixed(2) + '%');
      } catch (e) { /* cross-origin of canvas geblokkeerd: foto blijft zoals hij is */ }
    };
    probe.src = src;
  }
  function run() {
    document.querySelectorAll('.lxh-pcard__media img').forEach(function (img) {
      if (img.complete && img.naturalWidth) fit(img); else img.addEventListener('load', function () { fit(img); }, { once: true });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
})();
